import type { RouteRecordRaw } from 'vue-router'

export const reservationsRoutes: RouteRecordRaw[] = [
  {
    path: '/reservations',
    name: 'reservations',
    component: () => import('./views/ReservationsView.vue'),
    meta: { requiresAuth: true, roles: ['owner', 'admin', 'staff'] },
  },
]
